import { render, staticRenderFns } from "./LeaderBoardSelectedList.vue?vue&type=template&id=698f972a&"
import script from "./LeaderBoardSelectedList.vue?vue&type=script&lang=js&"
export * from "./LeaderBoardSelectedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports